/* template */
<template><div class="coupon-item-wrap"><div class="coupon-content"><div class="coupon-left"><special-text :text="(item.product_desc)" :rules="(hightLghtRules)" class="coupon-amount"></special-text><mpx-image src="https://ut-static.udache.com/webx/fe-agility-wyc/V-YUklqRsiTphrkeaaNGI.png" class="cheng"></mpx-image><special-text :text="(couponNumber)" :rules="(hightLghtRules)" class="coupon-amount"></special-text></div><div class="coupon-right">{{item.cap_text}}</div></div><div class="coupon-desc"><mpx-view @tap="arrowClick" class="desc-box"><app-html :class='("desc-text "+(showDesc ? "show" : "hide"))' ref="descText" :html="(descText)"></app-html><div :class='("desc-arrow "+(showDesc ? "show" : "hide"))' v-if="(showArrow)"></div></mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m04913210"}'>
.coupon-item-wrap
  background: rgba(8,22,48,0.04);
  border-radius: 20rpx;
  min-height 231rpx
  .coupon-content
    position relative
    width 672rpx
    height 172rpx
    background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/ldIMV9G93_K0-3rfefVgP.png')
    background-size 100% 100%
    display flex
    align-items center
    .coupon-left
      width 486rpx
      display flex
      align-items center
      justify-content center
      font-family PingFangSC-Medium
      font-size 32rpx
      color #9E4D1F
      letter-spacing 0
      line-height 35.56rpx
      font-weight 500
      .coupon-amount
        display flex
        align-items center
        justify-content center
      .cheng
        opacity 0.6
        // color #9E4D1F
        // font-size 40rpx
        width 21rpx
        height 21rpx
        margin 0 22rpx -6rpx 20rpx
    .coupon-right
      padding 0 20rpx
      width 140rpx
      text-align center
      font-family PingFangSC-Regular
      font-size 22rpx
      color #FDF1E9
      font-weight 400
  .coupon-desc
    position relative
    width 670rpx
    text-align center
    font-size 22rpx
    color rgba(54,72,107,0.60)
    line-height 32rpx
    font-weight $fw-medium
    .desc-box
      position relative
      margin-top 14rpx
      padding-bottom 14rpx
      display flex
      align-items center
      justify-content center
    .desc-text
      display flex
      margin 0 65rpx
      &.show
        overflow: visible;
        -webkit-line-clamp: unset;
      &.hide
        height 32rpx
        word-wrap:break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /* autoprefixer: ignore next */
        -webkit-box-orient: vertical;
    .desc-arrow
      position absolute
      right 16rpx
      width 40rpx
      height 40rpx
      background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/Nspw-jpeiC21JLaOmrOia.png')
      background-size 14rpx 14rpx
      background-position: center
      background-repeat: no-repeat
      transition transform 0.3s ease
      &.show
        transform rotate(180deg)
      &.hide
        transform rotate(0)

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
// import { GlobalEnv } from '../../../lib/webx'
// import { EnumLang } from '../../../lib/webx/defines'
createComponent({
  properties: {
    item: Object,
  },
  data: {
    showDesc: false,
    showArrow: false,
    hightLghtRules: {
      '{x}': {
        style: 'color: #9E4D1F; font-family:DINAlternate-Bold; font-size:8.53vw; margin: -2vw 0.6vw 0 0.6vw',
      },
    },
  },
  computed: {
    duration() {
      if (
        this.item.duration
      ) {
        return this.item.duration.join(' , ')
      }
      return ''
    },
    descText() {
      const couponInfo = this.item || {}
      const durationDay = couponInfo.durationDay || this.$t('goodsDetail.noTimeLimit')
      if (couponInfo.carTypeAll) {
        return  this.duration ? `${couponInfo.carTypeAll} | ${durationDay} | ${this.duration}` : `${couponInfo.carTypeAll} | ${durationDay} `
      }
      return this.duration ? `${durationDay}  | ${this.duration}`  : durationDay
    },
    couponNumber() {
      return `{${this.item.couponNumber}}${this.$t('goodsDetail.num')}`
    },
  },
  methods: {
    arrowClick() {
      this.showDesc = !this.showDesc
    },
  },
  attached() {
    setTimeout(() => {
      const el = this.$refs.descText?.$el || {}
      // const targetHeight = GlobalEnv.lang === EnumLang['en-US'] ? 25 : 32
      if (el.scrollHeight > 25) {
        this.showArrow = true
      }
    }, 200)
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "fixed-coupon-package04913210",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'special-text':getComponent(require("../../../../node_modules/@didi/mpx-ui/src/components/special-text/index.mpx?component=true&componentId=index8d2b07c0")),'app-html':getComponent(require("../../common/rich-text.mpx?component=true&componentId=rich-text723effcf")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
